/**
 * [SECURITY] Guard de rota.
 *
 * Quando o backend marca o usuario com users.force_password_change=1,
 * este guard redireciona QUALQUER navegacao protegida para
 * /alterar-senha. A propria tela /alterar-senha eh excluida do bloqueio
 * para nao causar redirect loop.
 *
 * Tambem garante que usuario sem token volte para /login.
 *
 * Uso no Router.tsx:
 *   <Route path="/home"
 *          element={<RequireFreshPassword><Home /></RequireFreshPassword>} />
 */
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { GeralContext } from "../context/GeralContext";

const FORCE_CHANGE_ROUTE = "/alterar-senha";
const LOGIN_ROUTE = "/login";

interface Props {
  children: React.ReactNode;
}

const RequireFreshPassword: React.FC<Props> = ({ children }) => {
  const { token, forcePasswordChange } = useContext(GeralContext);
  const location = useLocation();

  if (!token) {
    return <Navigate to={LOGIN_ROUTE} replace state={{ from: location }} />;
  }

  if (forcePasswordChange && location.pathname !== FORCE_CHANGE_ROUTE) {
    return <Navigate to={FORCE_CHANGE_ROUTE} replace />;
  }

  return <>{children}</>;
};

export default RequireFreshPassword;
